export const TOOLTIP_HEADER_PADDING = 6;
export const TOOLTIP_WRAPPER_PADDING = 4;
export const TOOLTIP_CONTENT_PADDING =
  TOOLTIP_HEADER_PADDING + TOOLTIP_WRAPPER_PADDING;

export const DEFAULT_HEADER_LINES = 3;
export const MAX_HEADER_LINES = 5;
export const DEFAULT_SERIES_NAME_LINES = 1;
export const MAX_SERIES_NAME_LINES = 2;
export const DEFAULT_TRUNCATION_MODE = 'end';

export const SPACE_CHARACTER_WIDTH = 4;
const SYMBOL_CONTAINER_WIDTH = 24;
export const GAP_BETWEEN_COLUMNS = 12;
export const SYMBOL_AND_SPACING_WIDTH =
  SYMBOL_CONTAINER_WIDTH + GAP_BETWEEN_COLUMNS;

export const MIN_TOOLTIP_WIDTH = 200;
export const MAX_TOOLTIP_WIDTH = 480;

export const SCROLLBAR_WIDTH = 14;
